import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";

// Mirrors react-native's StatusBarStyle, redeclared here to keep this store platform-agnostic.
export type StatusBarStyle = "default" | "light-content" | "dark-content";

interface StatusBarState {
  barStyle?: StatusBarStyle;
  translucent?: boolean;
  backgroundColor?: string;
}

interface StatusBarActions {
  setBarStyle: (barStyle?: StatusBarStyle) => void;
  setTranslucent: (translucent?: boolean) => void;
  setBackgroundColor: (backgroundColor?: string) => void;
}

export const initialState: StatusBarState = {
  barStyle: "dark-content",
  translucent: true,
  backgroundColor: "transparent",
};

export const useStatusBarStore = createWithEqualityFn<StatusBarState & StatusBarActions>()(
  (set) => ({
    ...initialState,
    setBarStyle: (barStyle?: StatusBarStyle) => set({ barStyle }),
    setTranslucent: (translucent?: boolean) => set({ translucent }),
    setBackgroundColor: (backgroundColor?: string) => set({ backgroundColor }),
  }),
  shallow,
);
